<template>
  <div class="salesorderreport">
    <!--<div class="overlayLoad"></div>-->
    <v-content>    
      <div v-if="filterDrawer == true" style="z-index: 2; opacity: 0.8; background: #000; width: 100%; height: 100%; position: absolute; left: 0px; top: 0px;"></div>
      <v-navigation-drawer v-model="filterDrawer" right absolute light width="500" class="rightDrawer">
        <v-container ref="filterReload" v-if="filterNeedsReloadSo == true">
          <v-layout row wrap>
            <v-flex lg12>
              <h2 style="padding-top: 10%;"><center>Loading Filters<br /><span style="font-size: 12px;">Please Wait</span></center></h2>
            </v-flex>
          </v-layout>
        </v-container>
        <v-container ref="filterShow" v-if="filterNeedsReloadSo == false">
          <v-layout row wrap style="overflow: hidden !important;">
            <v-flex lg11>
              <h2>FILTER YOUR REPORT</h2>
            </v-flex>
            <v-flex lg1>
              <a @click.prevent="fncCloseDrawer">Cancel</a>
            </v-flex>
            <v-flex lg12>
              <!--<v-btn class="regenReport" :disabled="regenFalse" @click="fncSearchNewQuotes()">REGENERATE REPORT</v-btn>-->
              <v-btn class="regenReport" @click="fncSearchNewQuotes()">REGENERATE REPORT</v-btn>
              <v-btn class="clearfilters" style="float:left !important;" @click="fncClearFilter()">CLEAR ALL FILTERS</v-btn>
              <v-btn class="clearregen" style="float:left !important;" @click="fncSearchClearNewQuotes()">CLEAR & REGENERATE</v-btn>
            </v-flex>
            <v-flex lg12>
              <small v-if="soSearch != ''"><strong>You currently have search text which could affect your filters.</strong></small>
              <br /><h3 style="margin-bottom: 10px;">DATE</h3>
            </v-flex>
            <v-flex lg12 class="dates">
              <date-picker id="dashDateRep" valueType="format" class="quoteDateRep dashDateRep" v-model="reportDate[0]" placeholder="Start Date" format="YYYY-MM-DD" lang="en"></date-picker>
              <span v-if="soLoaded == true" class="toRep">to</span>
              <date-picker id="dashDateRep" valueType="format" class="quoteDateRep dashDateRep" v-model="reportDate[1]" placeholder="End Date" format="YYYY-MM-DD" lang="en"></date-picker>
              <v-btn @click="fncReloadFilters()" style="margin-top: 1px;" color="info">GO</v-btn>
            </v-flex>
            <v-flex lg12 class="or">
              <small>OR</small>
            </v-flex>
            <v-flex lg12>
              <v-select v-if="quoteFilter != 99 && quoteFilter > 0" class="dropdown dashDroprep" v-model="quoteFilter" style="width:14%;font-size:12px 1important;margin-top: -18px;" :items="dateOptions" @input="fncChangeQuotes('nonchange')" item-value="id" item-text="name" autocomplete solo single-line></v-select>
              <v-select v-else class="dropdown dashDroprep" v-model="quoteFilter" style="width:14%;font-size:12px 1important;margin-top: -18px;" :label="fncFilterLabel()" :items="dateOptions" @input="fncChangeQuotes('nonchange')" item-value="id" item-text="name" autocomplete solo single-line></v-select>
            </v-flex>
            <v-flex lg12 class="additional">
              <h3>OTHER</h3><br />
            </v-flex>
            <v-flex lg6 style="position:relative">
              <label class="mTop"><b>Vendor</b></label>
              <a class="filterDone" @click="fncReloadFilters()" v-if="fncCheckDone('vendor')">Done</a>
              <v-select ref="vendorSelect" @blur="fncCheckChange('vendor')" class="shortSelect" v-model="objVendor" :items="fncSetFilters('vendor')" item-text="name" item-value="id" autocomplete multiple @input="fncCheckDropdowns('vendor')"></v-select>
            </v-flex>
            <v-flex lg6 style="position:relative">
              <label class="mTop"><b>Store</b></label>
              <a class="filterDone" @click="fncReloadFilters()" v-if="fncCheckDone('store')">Done</a>
              <v-select ref="storeSelect" @blur="fncCheckChange('store')" class="shortSelect" v-model="objStore" :items="fncSetFilters('store')" item-text="name" item-value="id" autocomplete multiple @input="fncCheckDropdowns('store')"></v-select>
            </v-flex>
            <v-flex lg6 style="position:relative">
              <label class="mTop"><b>Status</b></label>
              <a class="filterDone" @click="fncReloadFilters()" v-if="fncCheckDone('status')">Done</a>
              <v-select ref="statusSelect" @blur="fncCheckChange('status')" class="shortSelect" v-model="objStatus" :items="fncSetFilters('status')" item-text="name" item-value="id" multiple autocomplete @input="fncCheckDropdowns('status')"></v-select>
            </v-flex>
          </v-layout>
        </v-container>
      </v-navigation-drawer>
      <v-container fluid>
        <v-layout row wrap>
          <center style="width:100%" v-if="soLoaded == false"><img class="imgLoader" src="../../shared/assets/images/3dloader.gif" /></center>
          <v-flex class="poSearchContainer" v-if="soLoaded == true" xs6 style="margin-bottom: 60px;">
            <div class="relative" style="position: relative;">
              <!--<a v-if="search != ''" @click.prevent="fncClearSearch" class="searchTypeClearFull" style=" left: 44% !important;"><i class="material-icons searchTypeClearText">close</i></a>-->
              <!--<v-text-field append-icon="search" label="Search" style="width:50%;display: block; float:left;margin-right:10px;" solo single-line v-model="search"></v-text-field>-->
              <v-text-field class="poSearchField" ref="poSearchField" v-model="soSearch" append-icon="search" label="Search" solo single-line></v-text-field>
              <v-btn class="dashGenerateRep qtGenerate" @click="fncSearchNewQuotes()" style="background: #333 !important; color: #fff !important;height: 30px;position: absolute; top: 4px; display: block; right: 2px;">SEARCH</v-btn>
              <v-btn v-if="soSearch != ''" class="dashGenerateRep qtGenerate" @click="fncClearPoSearch()" style="background: #333 !important; color: #fff !important;height: 30px;position: absolute; top: 4px; display: block; right: 67px;">CLEAR</v-btn>
              <!--<v-btn v-if="quoteReportLoaded == true && quotesLoaded == true && editLoading == false" class="dashGenerateRep qtGenerate" @click="fncClearSearchTop()" style="background: #333 !important; color: #fff !important;height: 30px;position: absolute; top: -1px; display: block; right: 72px;">CLEAR</v-btn>-->
              <!--<v-btn @click.prevent="fncToggleFilters" v-if="hasFilters == false" class="elevation-5" style="display: block; float:left;" color="info"><i class="material-icons">filter_list</i>Toggle Filters</v-btn>-->
              <v-btn @click.prevent="fncToggleFilters" class="elevation-5" style="position: absolute;height: 30px;top: 4px;display: block;right: -105px;" color="info"><i class="material-icons">filter_alt</i>Filters</v-btn>
              <v-btn v-if="hasFilters == true && ( objStore != '' && objStore[0] != 'all' ) || ( objVendor != '' && objVendor[0] != 'all' ) || ( objStatus != '' && objStatus[0] != 'all' ) || ( objDepartment != '' && objDepartment[0] != 'all' )" @click.prevent="fncClearFilters" class="elevation-5" style="position: absolute;height: 30px;top: 4px;display: block;right: -235px;" color="success"><i class="material-icons">clear</i>Clear Filters</v-btn>

              <!--<v-btn @click.prevent="fncClearFilters" v-if="hasFilters == true && ( objStore != '' && objStore[0] != 'all' ) || ( objVendor != '' && objVendor[0] != 'all' ) || ( objStatus != '' && objStatus[0] != 'all' ) || ( objDepartment != '' && objDepartment[0] != 'all' )" class="elevation-5" style="display: block; float:left;" color="red"><i class="material-icons">clear</i>Clear Filters</v-btn>-->
            </div>
          </v-flex>
          <v-flex xs6 id="so" v-if="soLoaded == true" class="soDatePanel">
            <date-picker id="dashDateRep" valueType="format" class="quoteDateRep dashDateRep" v-model="reportDate[0]" placeholder="Start Date" format="YYYY-MM-DD" lang="en" ></date-picker>
            <span class="soToRep"><strong>to</strong></span>
            <date-picker id="dashDateRep" valueType="format" class="quoteDateRep dashDateRep" v-model="reportDate[1]" placeholder="End Date" format="YYYY-MM-DD" lang="en"></date-picker>
            <v-btn @click="fncClearDateDropdown" style="margin-top: 1px;" color="info">GO</v-btn>

            <span class="soToRep"><strong>OR</strong></span>
            <v-select class="dropdown dashDroprep" v-model="soFilter" :items="dateOptions" @input="fncChangeDates()" item-value="id" item-text="name" :label="fncFilterLabel()" autocomplete solo single-line></v-select>
          </v-flex>
        </v-layout>
        <div v-if="soLoaded == true" id="salesReportTable" style="width:100%; overflow-y: auto">
          <v-pagination
            v-model="page"
            :length= this.totalPages
            :page= this.getPage
            :total-visible="7"
            v-if="totalPages > 1"
          ></v-pagination>
          <div class="paginationRecords" v-html="fncShowPaginationRecords()"></div>
          <v-data-table id="soTable" :headers="headers" :search="search" :items="salesOrderListFilter" class="elevation-1" disable-initial-sort :style="{ 'width': tableWidth+'px'}" :rows-per-page-items="[25]">
            <template slot="headers" slot-scope="row">
              <tr>
                <th class="reportFilters" valign="top" :width="header.width" v-for="header in headers">
                  <span class="headerTitle" v-if="header.text == 'Vendor'">
                    <span v-if="objVendor.length > 0 && objVendor.length > 0 && objVendor[0] != 'all'" class="rowHasFilter activator">VENDOR<i style="font-size: 16px !important; padding-left: 6px;position: relative; top: 3px;" class="material-icons">filter_alt</i></span>
                    <v-tooltip style="display: block; float: right;" bottom v-if="objVendor.length > 0 && header.text == 'Vendor' && objVendor[0] != 'all'">
                      <span slot="activator" style="display: block; width:100%;height:27px;margin-top: -13px;">&nbsp</span>
                      <span v-html="fncShowVendorFlter()"></span>
                    </v-tooltip>
                    <span v-else>VENDOR</span>
                  </span>
                  <span class="headerTitle" v-if="header.text == 'Store'">
                    <span v-if="objStore.length > 0 && objStore.length > 0 && objStore[0] != 'all'" class="rowHasFilter">STORE<i style="font-size: 16px !important; padding-left: 6px;position: relative; top: 3px;" class="material-icons">filter_alt</i></span>
                    <v-tooltip bottom v-if="objStore.length > 0 && header.text == 'Store' && objStore[0] != 'all'">
                      <span slot="activator" style="display: block; width:100%;height:27px;margin-top: -13px;">&nbsp</span>
                      <span v-html="fncShowStoreFlter()"></span>
                    </v-tooltip>
                    <span v-else>STORE</span>
                  </span>
                  <span class="headerTitle" v-if="header.text == 'Status'">
                    <span v-if="objStatus.length > 0 && objStatus.length > 0 && objStatus[0] != 'all'" class="rowHasFilter">STATUS<i style="font-size: 16px !important; padding-left: 6px;position: relative; top: 3px;" class="material-icons">filter_alt</i></span>
                    <v-tooltip bottom v-if="objStatus.length > 0 && header.text == 'Status' && objStatus[0] != 'all'">
                      <span slot="activator" style="display: block; width:100%;height:27px;margin-top: -13px;">&nbsp</span>
                      <span v-html="fncShowStatusFlter()"></span>
                    </v-tooltip>
                    <span v-else>STATUS</span>
                  </span>
                  <span class="headerTitle" v-if="header.text != 'Vendor' && header.text != 'Store' && header.text != 'Status'">
                    {{ fncUpper(header.text) }}
                  </span>
                  <!--<span class="headerTitle" v-if="header.text != 'Vendor' || header.text != 'Store' || header.text != 'Status'">
                    {{ fncUpper(header.text) }}
                    <v-tooltip bottom v-if="reportDate != '' && header.text == 'Date'">
                      <i slot="activator" class="material-icons">info</i>
                      <span v-html="fncShowDateFilter()"></span>
                    </v-tooltip>
                    <span v-if="objVendor.length > 0 && header.text == 'Vendor' && objVendor[0] != 'all'" style="pointer-events: none;" class="filterActiveText">Enabled</span>
                    <v-tooltip bottom v-if="objVendor.length > 0 && header.text == 'Vendor' && objVendor[0] != 'all'">
                      <i slot="activator" class="material-icons">info</i>
                      <span v-html="fncShowVendorFlter()"></span>
                    </v-tooltip>
                    <span v-if="objStore.length > 0 && header.text == 'Store' && objStore[0] != 'all'" style="pointer-events: none;" class="filterActiveText">Enabled</span>
                    <v-tooltip bottom v-if="objStore.length > 0 && header.text == 'Store' && objStore[0] != 'all'">
                      <i slot="activator" class="material-icons">info</i>
                      <span v-html="fncShowStoreFlter()"></span>
                    </v-tooltip>
                    <span v-if="objStatus.length > 0 && header.text == 'Status' && objStatus[0] != 'all'" style="pointer-events: none;" class="filterActiveText">Enabled</span>
                    <v-tooltip bottom v-if="objStatus.length > 0 && header.text == 'Status' && objStatus[0] != 'all'">
                      <i slot="activator" class="material-icons">info</i>
                      <span v-html="fncShowStatusFlter()"></span>
                    </v-tooltip>
                    <span v-if="objDepartment.length > 0 && header.text == 'Department' && objDepartment[0] != 'all'" style="pointer-events: none;" class="filterActiveText">Enabled</span>
                    <v-tooltip bottom v-if="objDepartment.length > 0 && header.text == 'Department' && objDepartment[0] != 'all'">
                      <i slot="activator" class="material-icons">info</i>
                      <span v-html="fncShowDepartmentFlter()"></span>
                    </v-tooltip>
                  </span>-->
                  <!--<date-picker @input="fncCustomReportSearch()" ref="dateSelect" range v-if="header.text == 'Quote Date' && filterActive == true" class="quoteDate" v-model="reportDate" placeholder="Date Range" format="YYYY-MM-DD" lang="en"></date-picker>-->
                  <!--<div @click="fncBlurAll" style="position: relative;" v-if="header.text == 'Vendor' && filterActive == true">
                    <a class="filterDone" style="top:3px !important;right: 3px !important;" @click="fncCustomReportSearch()" v-if="vendorBlur == true">Done</a>
                    <v-select @blur="fncBlurAll" ref="vendorSelect" v-if="objVendor.length > 0 && objVendor[0] != 'all'" @input="fncCheckVendor()" v-model="objVendor" :items="objSalesOrderFilters.vendors" item-value="id" autocomplete multiple outline class="headerSelect hideValues hasSomeFilters"></v-select>
                    <v-select @blur="fncBlurAll" ref="vendorSelect" v-else @input="fncCheckVendor()" v-model="objVendor" :items="objSalesOrderFilters.vendors" item-value="id" autocomplete multiple outline class="headerSelect hideValues hasNoFilters"></v-select>
                  </div>
                  <div @click="fncBlurAll" style="position: relative;" v-if="header.text == 'Store' && filterActive == true">
                    <a class="filterDone" style="top:3px !important;right: 3px !important;" @click="fncCustomReportSearch()" v-if="storeBlur == true">Done</a>
                    <v-select @blur="fncBlurAll" ref="storeSelect" v-if="objStore.length > 0 && objStore[0] != 'all'" @input="fncCheckStore()" v-model="objStore" :items="objSalesOrderFilters.store" item-value="id" autocomplete multiple outline class="headerSelect hideValues hasSomeFilters"></v-select>
                    <v-select @blur="fncBlurAll" ref="storeSelect" v-else @input="fncCheckStore()" v-model="objStore" :items="objSalesOrderFilters.store" item-value="id" autocomplete multiple outline class="headerSelect hideValues hasNoFilters"></v-select>
                  </div>
                  <div @click="fncBlurAll" style="position: relative;" v-if="header.text == 'Status' && filterActive == true">
                    <a class="filterDone" style="top:3px !important;right: 3px !important;" @click="fncCustomReportSearch()" v-if="statusBlur == true">Done</a>
                    <v-select @blur="fncBlurAll" ref="statusSelect" @input="fncCheckStatus()" v-if="objStatus.length > 0 && objStatus[0] != 'all'" v-model="objStatus" :items="objSalesOrderFilters.status" item-value="id" autocomplete multiple outline class="headerSelect hideValues hasSomeFilters"></v-select>
                    <v-select @blur="fncBlurAll" ref="statusSelect" @input="fncCheckStatus()" v-else v-model="objStatus" :items="objSalesOrderFilters.status" item-value="id" autocomplete multiple outline class="headerSelect hideValues hasNoFilters"></v-select>
                  </div>
                  <div @click="fncBlurAll" style="position: relative;" v-if="header.text == 'Department' && filterActive == true">
                    <a class="filterDone" style="top:3px !important;right: 3px !important;" @click="fncCustomReportSearch()" v-if="departmentBlur == true">Done</a>
                    <v-select @blur="fncBlurAll" ref="departmentSelect" @input="fncCheckDepartment()" v-if="objDepartment.length > 0 && objDepartment[0] != 'all'" v-model="objDepartment" :items="objSalesOrderFilters.departments" item-value="id" autocomplete multiple outline class="headerSelect hideValues hasSomeFilters"></v-select>
                    <v-select @blur="fncBlurAll" ref="departmentSelect" @input="fncCheckDepartment()" v-else v-model="objDepartment" :items="objSalesOrderFilters.departments" item-value="id" autocomplete multiple outline class="headerSelect hideValues hasNoFilters"></v-select>
                  </div>-->
                </th>
              </tr>
            </template>
            <template slot="items" slot-scope="props">
              <td width="100px" v-if="hasOrders == true">{{ fncCheckOrderNo(props.item) }}</td>
              <td width="200px" v-if="hasOrders == true">
                <v-btn @click.prevent="fncPlaceOrder(props.item)" v-if="fncCanOrder(props.item)" class="elevation-5" color="info">Place Order</v-btn>
                <i v-if="fncCanCancelOrder(props.item)" title="Ordered" style="color: green !important;display: block; float:left;padding-top: 0px !important;" class="material-icons tick">check</i><span v-if="fncCanCancelOrder(props.item)" style="display: block; float:left;color: green;padding-top: 4px; padding-left: 5px;">Ordered</span>
                <i v-if="fncIsCancelOrder(props.item) && !fncCanOrder(props.item)" title="Order Cancelled" style="color: red !important;display:block;float:left;padding-top: 0px !important;" class="material-icons tick">close</i><span v-if="fncIsCancelOrder(props.item) && !fncCanOrder(props.item)" style="display: block; float:left;color: red;padding-top: 4px; padding-left: 5px;">Cancelled</span>
                <i v-if="fncIsCancelOrder(props.item) && fncCanOrder(props.item)" title="Order Cancelled" style="color: red !important;display:block;float:left;padding-top: 12px !important;" class="material-icons tick">close</i>
                <small v-if="!fncCanOrder(props.item) && !fncCanCancelOrder(props.item) && !fncIsCancelOrder(props.item)">-</small>
              </td>
              <td width="100px">
                <v-menu offset-y>
                  <i style="color: #00a99d;" class="material-icons" slot="activator">cloud_download</i>
                  <v-list>
                    <v-list-tile @click.prevent="fncViewSalesOrder(props.item, false)" v-if="objAuthorize.privileges.indexOf('VENDOR_REPORT') !== -1">
                      <v-list-tile-title>
                        <a>View Order</a>
                      </v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile @click.prevent="fncDownloadCsv(props.item)" v-show="props.orderNo != '' && props.item.ordered == 1">
                      <v-list-tile-title>
                        <a>Download Order – Excel</a>
                      </v-list-tile-title>
                    </v-list-tile>
                  </v-list>
                </v-menu>
              </td>
              <td v-if="objAuthorize.privileges.indexOf('VENDOR_FACTORY') != -1" width="175px">
                <v-btn v-if="objAuthorize.privileges.indexOf('VENDOR_FACTORY') != -1" @click="fncPrintStatus(props.item)" class="elevation-5" color="info" style="margin-right:10px;background: #333 !important;color: #fff !important;float: left;"><i class="material-icons print">print</i>Print Jobcard</v-btn>
              </td>
              <td v-if="objAuthorize.privileges.indexOf('VENDOR_FACTORY') != -1 && fncCheckArticles(props.item)" width="175px">
                <v-btn v-if="objAuthorize.privileges.indexOf('VENDOR_FACTORY') != -1" @click="fncPrintTaxInvoice(props.item)" class="elevation-5" color="info" style="margin-right:10px;background: #333 !important;color: #fff !important;float: left;"><i class="material-icons print">print</i>Print Invoice</v-btn>
              </td>
              <td v-if="objAuthorize.privileges.indexOf('VENDOR_FACTORY') != -1 && !fncCheckArticles(props.item)" width="175px">N/A</td>
              <td v-for="(item, index) in soColumns" :width="fncGetWidth(item.id)" v-if="item.checked">
                <div class="nowrap">
                <span v-if="item.id == 'quoteRegion'">{{ fncGetRegion(props.item.items) }}</span>
                <span v-if="item.id == 'soQty'">{{ fncGetQty(props.item.items) }}</span>
                <span v-if="item.id == 'soGlassType'">{{ fncGetGlassType(props.item.items) }}</span>
                <span v-if="item.id == 'soGlassSize'">{{ fncGetGlassSize(props.item.items) }}</span>
                <span v-if="item.id == 'soBranch'" style="display: inline-block; padding-top: 10px;">{{ fncGetBranch(props.item) }}</span>
                <span v-if="item.id == 'items'">{{ fncItemLength(props.item.items) }}</span>
                <span v-if="item.id == 'customerRating'">{{ fncGetCustomerRating(props.item) }}</span>
                <span v-if="item.id == 'installationDate'">{{ fncGetInstallationDate(props.item.items) }}</span>
                <span v-if="item.id == 'installationDescription'">{{ fncGetInstallationDescription(props.item.items) }}</span>
                <span v-if="item.id == 'onsiteTime'">{{ fncGetOnsiteTime(props.item) }}</span>
                <span v-if="item.id == 'jobComplete'">{{ fncGetJobComplete(props.item) }}</span>
                <span v-if="item.id == 'cancellationReason'">{{ fncGetCancellationReason(props.item) }}</span>
                  <a v-if="item.id == 'quoteNo' && ( props.item.quoteAttachment > 0 || props.item.soAttachment > 0 )" @click.prevent="fncSoSettings(props.item)" class="reportAttachment"><i class="material-icons">attach_file</i></a>
                  <a v-if="item.id == 'quoteNo' && ( props.item.quoteAttachment == 0 && props.item.soAttachment == 0 )" @click.prevent="fncSoSettings(props.item)" class="reportAttachment"><i style="opacity: 0.2;" class="material-icons">attach_file</i></a>
                <span v-if="item.id == 'quoteNo'" style="display: inline-block; padding-top: 10px;">{{ props.item[item.id] }}</span>
                <span v-if="item.id == 'bwSoNo'" style="display: inline-block; padding-top: 10px;">{{ props.item.bwSalesOrderNo }}</span>
                <span v-if="item.id == 'serviceType'" style="display: inline-block; padding-top: 10px;">{{ fncGetServiceType( props.item ) }}</span>
                <span v-if="item.id != 'responsibleReps' && item.id != 'customerRating' && item.id != 'jobComplete' && item.id != 'items' && item.id != 'status' && item.id != 'quoteNo'">{{ props.item[item.id] }}</span>
                <span v-if="item.id == 'soDepartment'" style="display: inline-block;">{{ props.item.departmentName }}</span>
                <span v-if="item.id == 'purchaseOrder'" style="display: inline-block;">{{ props.item.items[0].purchase_order_number }}</span>
                <span v-if="item.id != 'responsibleReps' && item.id != 'purchaseOrder' && item.id != 'items' && item.id != 'status' && item.id != 'quoteNo' && item.id != 'quoteNo' && item.id != 'vendorName' && item.id != 'originatorName' && item.id != 'soNo' && item.id != 'bwSalesOrderNo'">{{ props.item[item.id] }}</span>
                <span v-if="item.id != 'responsibleReps' && item.id != 'purchaseOrder' && item.id != 'items' && item.id != 'status' && item.id != 'quoteNo' && item.id != 'quoteNo' && item.id != 'vendorName' && item.id != 'originatorName' && item.id != 'soNo' && item.id != 'bwSalesOrderNo'">{{ props.item[item.id] }}</span>
                <span style="display: block !important; float: right !important;" v-if="item.id == 'totalPrice'" v-html="fncFormatPrice(props.item,props.item.currency,props.item.totalPrice )"></span>
                </div>
                  <div class="nowrap status-container">
                <span v-if="item.id == 'status' && objAuthorize.privileges.indexOf('VENDOR_FACTORY') == -1">{{ props.item.status }}</span>
                <span style="width: 100%;font-size:12px;display: inline-block; float: left; padding-left: 10px;padding-top:14px;" v-if="item.id == 'status' && objAuthorize.privileges.indexOf('VENDOR_FACTORY') != -1"><strong>Current Status:</strong><div class="currentStatus">{{ fncGetStatus(props.item) }}</div></span>

                <v-btn style="font-weight: bold;-webkit-box-shadow: 7px 7px 14px -9px rgba(0,0,0,0.5) !important;-moz-box-shadow: 7px 7px 14px -9px rgba(0,0,0,0.5) !important;box-shadow: 7px 7px 14px -9px rgba(0,0,0,0.5) !important;margin-right:10px;display: block; float: right; clear: both; font-size: 10px !important;" @click.prevent="fncGetNextStatusId(props.item)" v-if="item.id == 'status' && props.item.statusText != false && objAuthorize.privileges.indexOf('VENDOR_FACTORY') != -1" class="elevation-5" color="info">{{ props.item.statusText }}</v-btn>
                <span style="font-size: 12px;font-weight:bold;padding-left: 10px;display: block; float: left;padding-top: 16px;" v-show="filterDrawer == false && item.id == 'status' && props.item.statusText != false && objAuthorize.privileges.indexOf('VENDOR_FACTORY') != -1">Advance To:</span>



                <span @click="fncChangeReportStatus(props.item, props.item.items[0].statusId, false, true)" v-if="item.id == 'status' && objAuthorize.privileges.indexOf('VENDOR_FACTORY') == -1"><v-btn class="elevation-5" color="info">UPDATE STATUS</v-btn></span>
                    <a v-if="item.id == 'status' && objAuthorize.privileges.indexOf('VENDOR_FACTORY') == -1" href="#" @click.prevent="fncViewStatusPopup(props.item)"><i title="Status History" class="material-icons">history</i></a>
                <v-btn color="info" style="float:right"  v-if="item.id == 'responsibleReps' && fncCanSetVendorUsers(item, props.item)" @click="fncSetVendorUsers(item, props.item)">Update</v-btn>

                <span v-if="item.id == 'responsibleReps' && fncCanSetVendorUsers(item, props.item)" style="display: inline-block; padding-top: 15px;" v-html="fncGetResponsibleReps( props.item, item )"></span>
                <span v-if="item.id == 'responsibleReps' && !fncCanSetVendorUsers(item, props.item)"><strong>No Users Available To Select From</strong></span>
                </div>
                  <!--<span style="position: relative;top: 15px;" v-if="!isNaN(item.id) && fncCanSetVendorUsers(item, props.item)" v-html="fncGetResponsibleReps( props.item, item )"></span>
                <span v-if="!isNaN(item.id) && !fncCanSetVendorUsers(item, props.item)"><strong>No Users Available To Select From</strong></span>-->
              </td>
            </template>
          </v-data-table>
        </div>
      </v-container>
    </v-content>
  </div>
</template>

<script>

  import { mapGetters } from 'vuex';
  import DatePicker from 'vue2-datepicker'

  export default {
    name: 'RoleList',
    intRoleEdit: 0,
    data() {
      return {
        soSearch: window.localStorage.soSearch != undefined && window.localStorage.soSearch != null ? window.localStorage.soSearch : '',
        quoteFilter: '',
        filterNeedsReload: false,
        filterDrawer: false,
        totalPages: 1,
        getPage: 1,
        page: 1,
        totalQuoteRecords: 0,
        search: '',
        tableWidth: 200,
        headers: [],
        colFiltered: false,
        reportDate: window.localStorage.soDate != undefined && window.localStorage.soDate != null ? this.setDates() : '',
        objVendor: window.localStorage.soVendors != undefined && window.localStorage.soVendors[0] != null ? window.localStorage.soVendors.split(',') : ['all'],
        objStore: window.localStorage.soStores != undefined && window.localStorage.soStores[0] != null ? window.localStorage.soStores.split(',') : ['all'],
        objStatus: window.localStorage.soStatus != undefined && window.localStorage.soStatus[0] != null ? window.localStorage.soStatus.split(',') : ['all'],
        objDepartment: window.localStorage.soDepartment != undefined && window.localStorage.soDepartment[0] != null ? window.localStorage.soDepartment.split(',') : ['all'],
        filterActive: false,
        vendorBlur: false,
        storeBlur: false,
        departmentBlur: false,
        statusBlur: false,
        hasFilters: false,
        loaded: false,
        orderStatuses: [],
        hasOrders: false,
        appUrl: '',
        dateOptions: [
          { id: 1, name: 'View All Purchase Orders' },
          { id: 2, name: 'View Last 6 Months' },
          { id: 3, name: 'View Last 90 Days' },
          { id: 4, name: 'View Last 60 Days' },
          { id: 5, name: 'View Last 30 Days' },
          { id: 6, name: 'View Last 7 Days' }
        ],
        soFilter: 0,
        filterVendorDone: false,
        filterStoreDone: false,
        filterStatusDone: false,
        departmentProductCodes: [],
        vendorUserList: []
      }
    },
    methods: {
      fncGetResponsibleReps( item, menuItem ) {
        if( item.responsibleReps[item.vendor] != undefined && item.responsibleReps[item.vendor] != undefined ) {
          if( item.responsibleReps != 'Not Set' && item.responsibleReps[item.vendor].length > 0 ) {

            var stringUsers = item.responsibleReps[item.vendor].join(', ');
            if( stringUsers.length > 30 ) {
              return stringUsers.substr(0,30) + ' ...';
            }
            return stringUsers;
          } else {
            return 'Not Set';
          }
        }
        return 'Not Set';
      },
      fncCanSetVendorUsers( item, lineItem ) {
        var canSet = false;
        if( this.vendorUserList[lineItem.vendor] != undefined ) {
          //if( this.vendorUserList[lineItem.vendor][item.id] != undefined ) {
            canSet = true;
          //}
        }
        return canSet;
      },
      fncSetVendorUsers( item, lineItem ) {
        if( this.vendorUserList[lineItem.vendor] != undefined ) {
          if( this.vendorUserList[lineItem.vendor] != 'Not Set' ) {
            var modalDetails = { title: 'Update Person Responsible For POD', component: 'modal-set-so-reps', mstate: true, params: { users: this.vendorUserList[lineItem.vendor], quoteId: lineItem.quoteId } };
            this.$store.commit({
              type: 'setModal',
              details: modalDetails
            });
          }
        }
      },
      fncClearPoSearch() {

        this.soSearch = '';
        this.fncSearchNewQuotes();

      },
      fncCheckSearchText() {
        if( this.soSearch != '' ) {
          return true;
        }
        return false;
      },
      fncGetRegion( items ) {
        var regionSplit = items[0].spec.split('<td class="quoteRegion">');
        if( regionSplit.length > 1 ) {
          var regionSplitName = regionSplit[1].split('</td>');
          return regionSplitName[0];
        } else {
          return 'N/A';
        }
      },
      fncSearchClearNewQuotes() {

        /*localStorage.removeItem('quote_start_date');
        localStorage.removeItem('quote_end_date');
        localStorage.removeItem('reportDates');
        localStorage.removeItem('quoteSetDays');*/

        localStorage.removeItem('cancelSoVendor');
        localStorage.removeItem('cancelSoStore');
        localStorage.removeItem('cancelSoStatus');
        /*localStorage.removeItem('cancelReportDate');
        localStorage.removeItem('cancelQuoteSetDays');*/

        /*this.regenFalse = false;
        this.reportDate[0] = '';
        var dToday = new Date();
        var quote_age_end = dToday.toISOString().split('T')[0];
        this.reportDate[1] = quote_age_end;
        this.quoteFilter = '';
        this.search = '';*/
        this.objSoVendor = ['all'];
        this.objSoStore = ['all'];
        this.objSoStatus = ['all'];

        //localStorage.removeItem('soSetDays');
        this.soFilter = 0;
        this.hasFilters = false;
        //this.reportDate = '';

        this.filterDrawer = false;
        this.$store.dispatch({
          type: 'fncPopulateSalesOrders',
          reload: false,
          vendors: [],
          stores: [],
          status: [],
          soDates: this.reportDate
        });



      },
      fncCloseDrawer() {
        // this.filterDrawer = false;

        if (window.localStorage.cancelSoVendor != undefined && window.localStorage.cancelSoVendor != null) {
          localStorage.setItem('soVendors', localStorage.getItem('cancelSoVendor'));
        }

        if (window.localStorage.cancelSoStore != undefined && window.localStorage.cancelSoStore != null) {
          localStorage.setItem('soStores', localStorage.getItem('cancelSoStore'));
        }

        if (window.localStorage.cancelSoStatus != undefined && window.localStorage.cancelSoStatus != null) {
          localStorage.setItem('soStatus', localStorage.getItem('cancelSoStatus'));
        }

        /* if (window.localStorage.cancelReportDate != undefined && window.localStorage.cancelReportDate != null) {
          var newReportDate = localStorage.getItem('cancelReportDate').split(',');
          if (newReportDate[0] == '1900-01-01') {
            newReportDate[0] = '';
          }
          localStorage.setItem('reportDates', newReportDate.toString());
          //localStorage.setItem('reportDates', localStorage.getItem('cancelReportDate'));
          this.reportDate = newReportDate;
          localStorage.setItem('quote_start_date', newReportDate[0].toString());
          localStorage.setItem('quote_end_date', newReportDate[1].toString());

          //this.reportDate = localStorage.getItem('cancelReportDate');
        }

        if (window.localStorage.cancelQuoteSetDays != undefined && window.localStorage.cancelQuoteSetDays != null) {
          localStorage.setItem('quoteSetDays', localStorage.getItem('cancelQuoteSetDays'));
        }*/

        // do a reload
        setTimeout(function () {
          location.reload();
        }, 1000)
      },
      fncReloadFilters() {

        this.$store.dispatch({
          type: 'fncPopulateSalesOrdersFilters',
          reload: false,
          vendors: this.objVendor[0] != 'all' ? this.objVendor : [],
          stores: this.objStore[0] != 'all' ? this.objStore : [],
          status: this.objStatus[0] != 'all' ? this.objStatus : [],
          soDates: this.reportDate
        });
        this.$store.commit('fncFilterNeedsReloadSo', true);
        this.filterDrawer = true;
        /* this.$store.commit('fncFilterNeedsReload', true);
        this.fncShowFilterSlideSub(); */
      },
      fncCheckDropdowns(type) {
        this.regenFalse = false;
        var newFilter = [];
        var isAll = false;
        var addedObj = false;
        if( type == 'vendor' ) {
          for( var v in this.objVendor ) {
            if( this.objVendor[v] == 'all' ) {
              isAll = true;
            }
          }
          var lastClicked = this.objVendor[this.objVendor.length -1];
          if( isAll == true && this.objVendor.length == 1 ) {
            newFilter.push('all');
            addedObj = true;
          } else if( lastClicked == 'all' ) {
            newFilter.push('all');
            addedObj = true;
          } else {
            for( var v in this.objVendor ) {
              if (this.objVendor[v] != 'all') {
                newFilter.push(this.objVendor[v]);
                addedObj = true;
              }
            }
          }
          if( addedObj == false ) {
            newFilter.push('all');
          }
          this.objVendor = newFilter;
        } else if( type == 'store' ) {
          for( var s in this.objStore ) {
            if( this.objStore[s] == 'all' ) {
              isAll = true;
            }
          }
          var lastClicked = this.objStore[this.objStore.length -1];
          if( isAll == true && this.objStore.length == 1 ) {
            newFilter.push('all');
            addedObj = true;
          } else if( lastClicked == 'all' ) {
            newFilter.push('all');
            addedObj = true;
          } else {
            for( var s in this.objStore ) {
              if (this.objStore[s] != 'all') {
                newFilter.push(this.objStore[s]);
                addedObj = true;
              }
            }
          }
          if( addedObj == false ) {
            newFilter.push('all');
          }
          this.objStore = newFilter;
        } else if( type == 'status' ) {
          for( var s in this.objStatus ) {
            if( this.objStatus[s] == 'all' ) {
              isAll = true;
            }
          }
          var lastClicked = this.objStatus[this.objStatus.length -1];
          if( isAll == true && this.objStatus.length == 1 ) {
            newFilter.push('all');
            addedObj = true;
          } else if( lastClicked == 'all' ) {
            newFilter.push('all');
            addedObj = true;
          } else {
            for( var s in this.objStatus ) {
              if (this.objStatus[s] != 'all') {
                newFilter.push(this.objStatus[s]);
                addedObj = true;
              }
            }
          }
          if( addedObj == false ) {
            newFilter.push('all');
          }
          this.objStatus = newFilter;
        }

      },
      fncSearchNewQuotes( isSingleDate = false ) {

        /* if( isSingleDate ==  true ) {
          localStorage.setItem('quoteSetDays','');
        }

        this.pagination.page = 1;

        if( this.reportDate.length != 2 ) {
          var start_date = '';
          var end_date = '';
        } else {
          var start_date = this.reportDate[0];
          if( start_date && start_date.length != 10 && start_date.length != 0 ) {
            var new_start_date = new Date(start_date);
            new_start_date.setDate(new_start_date.getDate() + 1);
            start_date = new_start_date.toISOString().split('T')[0]
          }

          localStorage.setItem('quote_start_date', start_date);

          var end_date = this.reportDate[1];
          if( end_date.length != 10 && end_date.length != 0 ) {
            var new_end_date = new Date(end_date);
            new_end_date.setDate(new_end_date.getDate() + 1);
            end_date = new_end_date.toISOString().split('T')[0]
          }

          localStorage.setItem('quote_end_date', end_date);
        }

        if( start_date == '' ) {
          start_date = '1900-01-01';
        }

        if( end_date == '' ) {
          var today = new Date();
          var dd = String(today.getDate()).padStart(2, '0');
          var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
          var yyyy = today.getFullYear();

          end_date = yyyy + '-' + mm + '-' + dd;
        }

        var reportDates = [];
        reportDates.push( start_date );
        reportDates.push( end_date );

        localStorage.setItem('quote_start_date', start_date);
        localStorage.setItem('quote_end_date', end_date);
        localStorage.setItem('reportDates', reportDates.toString());*/

        /* New */
        if( this.soSearch != '' ) {
          localStorage.setItem('soSearch', this.soSearch);
        } else {
          localStorage.removeItem('soSearch');
        }

        if (this.objStatus != '' && this.objStatus[0] != 'all' ) {
          localStorage.setItem('soStatus', JSON.stringify(this.objStatus));
        } else {
          localStorage.removeItem('soStatus');
        }

        if (this.objVendor != '' && this.objVendor[0] != 'all') {
          localStorage.setItem('soVendors', JSON.stringify(this.objVendor));
        } else {
          localStorage.removeItem('soVendors');
        }

        if (this.objStore != '' && this.objStore[0] != 'all') {
          localStorage.setItem('soStores', JSON.stringify(this.objStore));
        } else {
          localStorage.removeItem('soStores');
        }

        /*if( start_date == '' ) {
          start_date = '1900-01-01';
        }
        if( end_date == '' ) {
          var today = new Date();
          var dd = String(today.getDate()).padStart(2, '0');
          var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
          var yyyy = today.getFullYear();

          end_date = yyyy + '-' + mm + '-' + dd;
        }*/

        this.$router.push({path: '/reports/sales-order-reports', query: 1});
        this.$router.go();

      },
      fncChangeQuotes( actionType, doReload = false ) {

        if( actionType == 'nonchange' ) {

          this.nonClickable = false;

          this.regenFalse = false;

          var dToday = new Date();
          var dateToday = dToday.toISOString().split('T')[0];
          // localStorage.getItem('reportDates');
          switch(this.quoteFilter) {
            case 1:
              this.reportDate = '';
              var startDate = '1900-01-01';
              break;
            case 2:
              var d = new Date();
              d.setMonth(d.getMonth() - 6);
              var startDate = d.toISOString().split('T')[0];
              break;
            case 3:
              var startDate = new Date(new Date().setDate(dToday.getDate() - 90));
              startDate = startDate.toISOString().split('T')[0];
              break;
            case 4:
              var startDate = new Date(new Date().setDate(dToday.getDate() - 60));
              startDate = startDate.toISOString().split('T')[0];
              break;
            case 5:
              var startDate = new Date(new Date().setDate(dToday.getDate() - 30));
              startDate = startDate.toISOString().split('T')[0];
              break;
            case 6:
              var startDate = new Date(new Date().setDate(dToday.getDate() - 7));
              startDate = startDate.toISOString().split('T')[0];
              break;
          }

          this.reportDate = [];

          if( startDate != '1900-01-01' ) {
            this.reportDate.push( startDate );
            this.reportDate.push( dateToday );
          }

          localStorage.setItem('soSetDays', this.quoteFilter);

        } else if( actionType == true ) {

          var checkStart = new Date(this.reportDate[0]);
          var checkEnd = new Date(this.reportDate[1]);

          if( checkStart > checkEnd ) {
            alert('Start date must be bigger than the end date');
          } else {
            this.$store.commit('fncEmptyDashboard');
            this.$store.commit('fncIsLoaded', false);
            this.statuses = [];

            var newDates = [];
            for( var q in this.reportDate ) {
              if( this.reportDate[q].length == 10 ) {
                newDates.push( this.reportDate[q] );
              } else {
                newDates.push( this.reportDate[q].toISOString().split('T')[0] );
              }
            }

            this.reportDate = newDates;

            if (this.reportDate.length > 0) {
              var start_date = this.reportDate[0];
              if (start_date.length != 10) {
                start_date = this.reportDate[0].substr(0, 10);
              }

              if (start_date != localStorage.getItem("quote_start_date")) {
                start_date = start_date;
              }
            } else {
              start_date = '';
            }

            if (this.reportDate.length > 0) {
              var end_date = this.reportDate[1];
              if (end_date.length != 10) {
                end_date = this.reportDate[1].substr(0, 10);
              }

              if (end_date != localStorage.getItem("quote_end_date")) {
                end_date = end_date;
              } else {
                end_date = localStorage.getItem("quote_end_date");
              }
            } else {
              end_date = '';
            }

          }

          //this.fncSearchNewQuotes();

        } else if( actionType == false ) {
          // this.$store.commit( 'fncIsLoaded', false );

          this.nonClickable = false;

          this.regenFalse = false;

          var dToday = new Date();
          var dateToday = dToday.toISOString().split('T')[0];
          // localStorage.getItem('reportDates');
          switch(this.quoteFilter) {
            case 1:
              this.reportDate = '';
              var startDate = '1900-01-01';
              break;
            case 2:
              var d = new Date();
              d.setMonth(d.getMonth() - 6);
              var startDate = d.toISOString().split('T')[0];
              break;
            case 3:
              var startDate = new Date(new Date().setDate(dToday.getDate() - 90));
              startDate = startDate.toISOString().split('T')[0];
              break;
            case 4:
              var startDate = new Date(new Date().setDate(dToday.getDate() - 60));
              startDate = startDate.toISOString().split('T')[0];
              break;
            case 5:
              var startDate = new Date(new Date().setDate(dToday.getDate() - 30));
              startDate = startDate.toISOString().split('T')[0];
              break;
            case 6:
              var startDate = new Date(new Date().setDate(dToday.getDate() - 7));
              startDate = startDate.toISOString().split('T')[0];
              break;
          }

          this.reportDate = [];

          if( startDate != '1900-01-01' ) {
            this.reportDate.push( startDate );
            this.reportDate.push( dateToday );
          }

          localStorage.setItem('soSetDays', this.quoteFilter);

        }

        if( actionType != 'nonchange' ) {
          if( doReload == true ) {
            // this.fncSearchNewQuotes();
          } else {
            // this.fncReloadFilters();
          }
        }

      },
      fncCheckChange( checkType ) {
        if( checkType == 'status' ) {
          if( this.$refs.statusSelect.isActive == false ) {
            if( JSON.stringify( this.objStatus ) != localStorage.getItem('cancelSoStatus') ) {
              if( this.objStatus[0] == 'all' ) {
                if( localStorage.getItem('cancelSoStatus') == null != undefined && localStorage.getItem('cancelSoStatus') == null ) {
                  // do nothing
                } else {
                  this.fncReloadFilters();
                }
              } else {
                this.fncReloadFilters();
              }
            }
          }
        } else if( checkType == 'store' ) {
          if( this.$refs.storeSelect.isActive == false ) {
            if( JSON.stringify( this.objStore ) != localStorage.getItem('cancelSoStore') ) {
              if( this.objStore[0] == 'all' ) {
                if( localStorage.getItem('cancelSoStore') == null != undefined && localStorage.getItem('cancelSoStore') == null ) {
                  // do nothing
                } else {
                  this.fncReloadFilters();
                }
              } else {
                this.fncReloadFilters();
              }
            }
          }
        } else if( checkType == 'vendor' ) {
          if( this.$refs.vendorSelect.isActive == false ) {
            if( JSON.stringify( this.objVendor ) != localStorage.getItem('cancelSoVendor') ) {
              if( this.objVendor[0] == 'all' ) {
                if( localStorage.getItem('cancelSoVendor') == null != undefined && localStorage.getItem('cancelSoVendor') == null ) {
                  // do nothing
                } else {
                  this.fncReloadFilters();
                }
              } else {
                this.fncReloadFilters();
              }
            }
          }
        }
      },
      fncCheckDone( type ) {
        if( type == 'vendor' ) {
          if( this.$refs.vendorSelect !=  undefined && this.$refs.vendorSelect.isActive == true ) {
            return true;
          } else {
            return false;
          }
        } else if( type == 'status' ) {
          if( this.$refs.statusSelect !=  undefined && this.$refs.statusSelect.isActive == true ) {
            return true;
          } else {
            return false;
          }
        } else if( type == 'customer' ) {
          if( this.$refs.customerSelect !=  undefined && this.$refs.customerSelect.isActive == true ) {
            return true;
          } else {
            return false;
          }
        } else if( type == 'originator' ) {
          if( this.$refs.originatorSelect !=  undefined && this.$refs.originatorSelect.isActive == true ) {
            return true;
          } else {
            return false;
          }
        } else if( type == 'store' ) {
          if( this.$refs.storeSelect !=  undefined && this.$refs.storeSelect.isActive == true ) {
            return true;
          } else {
            return false;
          }
        }
      },
      fncSetFilters( type ) {

        var toReturn = [{ id: 'all', name: 'All' }];
        var filters = this.newReportFilters;

        if( type == 'vendor' ) {
          var isSelected = [];
          var isNotSelected = [];
          for( var v in this.soFilters.vendor ) {
            if( this.objVendor.indexOf(String(v)) != -1 ) {
              isSelected.push({id: v, name: this.soFilters.vendor[v]})
            }
          }
          isSelected.sort((a, b) => a.name.localeCompare(b.name));
          for( var v in this.soFilters.vendor ) {
            if( this.objVendor.indexOf(String(v)) == -1 ) {
              isNotSelected.push({id: v, name: this.soFilters.vendor[v]})
            }
          }
          isNotSelected.sort((a, b) => a.name.localeCompare(b.name));
          toReturn = toReturn.concat(isSelected);
          toReturn = toReturn.concat(isNotSelected);
        } else if( type == 'store' ) {
          var isSelected = [];
          var isNotSelected = [];
          for( var s in this.soFilters.store ) {
            if( this.objStore.indexOf(String(s)) != -1 ) {
              isSelected.push({id: s, name: this.soFilters.store[s]});
            }
          }
          isSelected.sort((a, b) => a.name.localeCompare(b.name));
          for( var s in this.soFilters.store ) {
            if( this.objStore.indexOf(String(s)) == -1 ) {
              isNotSelected.push({id: s, name: this.soFilters.store[s]});
            }
          }
          isNotSelected.sort((a, b) => a.name.localeCompare(b.name));
          toReturn = toReturn.concat(isSelected);
          toReturn = toReturn.concat(isNotSelected);
        } else if( type == 'status' ) {

          var isSelected = [];
          var isNotSelected = [];
          for( var s in this.soFilters.status ) {
            if( this.objStore.indexOf(String(s)) != -1 ) {
              isSelected.push({id: s, name: this.soFilters.status[s]});
            }
          }
          isSelected.sort((a, b) => a.name.localeCompare(b.name));
          for( var s in this.soFilters.status ) {
            if( this.objStore.indexOf(String(s)) == -1 ) {
              isNotSelected.push({id: s, name: this.soFilters.status[s]});
            }
          }
          isNotSelected.sort((a, b) => a.name.localeCompare(b.name));
          toReturn = toReturn.concat(isSelected);
          toReturn = toReturn.concat(isNotSelected);

        } /* else {
            var isSelected = [];
            var isNotSelected = [];
            for( var s in filters.status ) {
              if( this.objStatus.indexOf(String(s)) != -1 ) {
                isSelected.push({id: s, name: s});
              }
            }
            isSelected.sort((a, b) => a.name.localeCompare(b.name));
            for( var s in filters.status ) {
              if( this.objStatus.indexOf(String(s)) == -1 ) {
                isNotSelected.push({id: s, name: s});
              }
            }
            isNotSelected.sort((a, b) => a.name.localeCompare(b.name));
            toReturn = toReturn.concat(isSelected);
            toReturn = toReturn.concat(isNotSelected);
          }
        } else if( type == 'originator' ) {
          var isSelected = [];
          var isNotSelected = [];
          for( var o in filters.originator ) {
            if( this.objOriginator.indexOf(String(o)) != -1 ) {
              isSelected.push({id: o, name: filters.originator[o]});
            }
          }
          isSelected.sort((a, b) => a.name.localeCompare(b.name));
          for( var o in filters.originator ) {
            if( this.objOriginator.indexOf(String(o)) == -1 ) {
              isNotSelected.push({id: o, name: filters.originator[o]});
            }
          }
          isNotSelected.sort((a, b) => a.name.localeCompare(b.name));
          toReturn = toReturn.concat(isSelected);
          toReturn = toReturn.concat(isNotSelected);
        } else if( type == 'customer' ) {
          var isSelected = [];
          var isNotSelected = [];
          for( var c in filters.customer ) {
            if( this.objCustomerUser.indexOf(String(c)) != -1 ) {
              isSelected.push({id: c, name: filters.customer[c]});
            }
          }
          isSelected.sort((a, b) => a.name.localeCompare(b.name));
          for( var c in filters.customer ) {
            if( this.objCustomerUser.indexOf(String(c)) == -1 ) {
              isNotSelected.push({id: c, name: filters.customer[c]});
            }
          }
          isNotSelected.sort((a, b) => a.name.localeCompare(b.name));
          toReturn = toReturn.concat(isSelected);
          toReturn = toReturn.concat(isNotSelected);
        } else if( type == 'department' ) {
          var isSelected = [];
          var isNotSelected = [];
          for( var d in filters.department ) {
            if( this.objDepartment.indexOf(String(d)) != -1 ) {
              isSelected.push({ id: d, name: filters.department[d] });
            }
          }
          isSelected.sort((a, b) => a.name.localeCompare(b.name));
          for( var d in filters.department ) {
            if( this.objDepartment.indexOf(String(d)) == -1 ) {
              isNotSelected.push({ id: d, name: filters.department[d] });
            }
          }
          isNotSelected.sort((a, b) => a.name.localeCompare(b.name));
          toReturn = toReturn.concat(isSelected);
          toReturn = toReturn.concat(isNotSelected);
        }*/

        return toReturn;

      },
      fncShowPaginationRecords() {

        var startPage = ( this.page * 10 ) - 9;
        var endPage = ( this.page * 10 );

        if( endPage > this.totalQuoteRecords ) {
          endPage = this.totalQuoteRecords;
        }

        return '<p>Viewing '+startPage+' - '+endPage+' of ' + this.totalQuoteRecords + ' records</p>';
      },
      fncCheckArticles( item ) {
        var canInvoice = true;
        /*for( var i in item.items ) {
          if( item.items[i].code == '750168' || item.items[i].code == '750169' ) {
            canInvoice = true;
          }
        }*/
        return canInvoice;
      },
      fncClearDateDropdown() {

        var dStart = new Date( this.reportDate[0] );
        dStart.setDate(dStart.getDate());
        var dateStart = dStart.toISOString().split('T')[0];

        var dEnd = new Date( this.reportDate[1] );
        var dateEnd = dEnd.toISOString().split('T')[0];

        this.reportDate = [];

        this.reportDate[0] = dateStart;
        this.reportDate[1] = dateEnd;

        localStorage.removeItem('soSetDays');
        localStorage.setItem('soDate', this.reportDate);
        this.fncCustomReportSearch();
      },
      fncChangeDates() {

        var dToday = new Date();
        var dateToday = dToday.toISOString().split('T')[0];

        switch(this.soFilter) {
          case 1:
            this.reportDate = '';
            var startDate = '1900-01-01';
            break;
          case 2:
            var d = new Date();
            d.setMonth(d.getMonth() - 6);
            var startDate = d.toISOString().split('T')[0];
            break;
          case 3:
            var startDate = new Date(new Date().setDate(dToday.getDate() - 90));
            startDate = startDate.toISOString().split('T')[0];
            break;
          case 4:
            var startDate = new Date(new Date().setDate(dToday.getDate() - 60));
            startDate = startDate.toISOString().split('T')[0];
            break;
          case 5:
            var startDate = new Date(new Date().setDate(dToday.getDate() - 30));
            startDate = startDate.toISOString().split('T')[0];
            break;
          case 6:
            var startDate = new Date(new Date().setDate(dToday.getDate() - 7));
            startDate = startDate.toISOString().split('T')[0];
            break;
          default:
            var startDate = new Date(new Date().setDate(dToday.getDate() - 7));
            startDate = startDate.toISOString().split('T')[0];
            break;
        }

        this.reportDate = [];

        if( startDate != '1900-01-01' ) {
          this.reportDate.push( startDate );
          this.reportDate.push( dateToday );
        }

        localStorage.setItem('soSetDays', this.soFilter);
        localStorage.setItem('soDate', this.reportDate);

        this.fncCustomReportSearch();

      },
      setDates() {
        return window.localStorage.reportDates.split(',');
      },
      fncFilterLabel() {
        var sDate = new Date(this.reportDate[0]);
        var eDate = new Date(this.reportDate[1]);
        var diffDays = parseInt((eDate - sDate) / (1000 * 60 * 60 * 24), 10);

        if (this.reportDate[0] == undefined) {
          return 'View All Quotes';
        } else if (diffDays == 30) {
          return 'View Last 30 Days';
        } else if (diffDays == 60) {
          return 'View Last 60 Days';
        } else if (diffDays == 90) {
          return 'View Last 90 Days';
        } else if (diffDays == 7) {
          return 'View Last Week';
        } else {
          return 'Set range';
        }
      },
      fncPrintTaxInvoice(order) {

        var modalDetails = { title: 'Set Purchase Order Number', component: 'modal-set-so-number', mstate: true, params: { order: order } };
        this.$store.commit({
          type: 'setModal',
          details: modalDetails
        });
        /*this.$store.dispatch({
          type: 'fncSetQuoteDetails',
          quoteId: order.quoteId,
          quote: order.quoteNo,
          so: true,
          order: order,
          vendorList: this.vendorList,
          privileges: this.objAuthorize.privileges,
          doPrintInvoice: true,
          hasStatus: ''
        });*/
        /*this.$store.dispatch({
          type: 'fncPrintInvoice',
          quoteId: order.quoteId,
          quote: order.quoteNo,
          so: true,
          order: order
        });*/

      },
      fncPrintStatus(item) {
        var statusList = this.fncGetStatusDropdown(item, 'status');
        var hasPrint = false;
        var printStatus = '';
        if( statusList.length > 0 ) {
          for( var s in statusList ) {
            if( ( statusList[s].is_print == 'Yes' || statusList[s].is_print == true ) && hasPrint == false ) {
              printStatus = statusList[s];
            }
          }
        }
        //this.fncChangeReportStatus( item, printStatus.id, true )
        this.fncViewSalesOrder( item, true, printStatus.id );
        var setThis = this;
        /*setTimeout(function(){
          setThis.fncChangeReportStatus( item, printStatus.id, true );
        }, 3000)*/
      },
      fncGetStatus(item) {
        return item.status;
      },
      fncGetNextStatus( item, column ) {
        if( item.status == 'Manufactured' || this.objAuthorize.privileges.indexOf('VENDOR_FACTORY') == '-1' ) {
          return false;
        } else {
          var statusList = this.fncGetStatusDropdown(item, 'status');

          /*          console.log( item.quoteNo );
                    console.log( statusList );*/

          var nextIndex = 0;
          for( var i in statusList ){
            if( statusList[i].description == item.status ) {
              nextIndex = parseInt(i) + 1;
            }
          }
          if( nextIndex >= statusList.length ) {
            return false;
          } else {
            return statusList[nextIndex].description;
          }
        }
      },
      /*fncGetBranch(item) {
        console.log('AND HERE');
        var parsedItem = JSON.parse( item.items[0].line_item_data );
        if( parsedItem.store_id != undefined && parsedItem.store_id != null ) {
          for( var b in this.branchList ) {
            if( this.branchList[b].code == parsedItem.store_id ) {
              return  this.branchList[b].name;
            }
          }
        } else {
          return 'N/A';
        }
      },*/
      fncGetNextStatusId( item ) {
        // props.item.items[0].statusId
        var statusList = this.fncGetStatusDropdown(item, 'status');

        var nextIndex = 0;
        for( var i in statusList ){
          if( statusList[i].description == item.status ) {
            nextIndex = parseInt(i) + 1;
          }
        }
        var nextId = statusList[nextIndex].id;

        this.fncChangeReportStatus( item, nextId, false, false );
      },
      fncGetGlassSize(items) {
        var specString = '';
        for( var i in items ) {
          if( items[i].spec != undefined && items[i].spec.indexOf('size-glass') != -1 ) {
            specString = items[i].spec;
          }
        }
        if( specString != '' ) {
          var specSplit = specString.split("<span class='size-glass'>");

          if( specSplit.length == 2 ) {
            var glassSize = specSplit[1].split('</span>');
            var toReturn = glassSize[0];
            toReturn = toReturn.replace( /(<([^>]+)>)/ig, '')
            return toReturn;
          } else {
            return 'N/A';
          }
        } else {
          return 'N/A';
        }
      },
      fncGetGlassType(items) {
        var specString = '';
        for( var i in items ) {
          if( items[i].spec != undefined && items[i].spec.indexOf('type-glass') != -1 ) {
            specString = items[i].spec;
          }
        }
        if( specString != '' ) {
          var specSplit = specString.split("<span class='type-glass'>");
          if( specSplit.length == 2 ) {
            var glassType = specSplit[1].split('</span></td>');
            var detailsSplit = glassType[0].split("</span><span class='glasstype'>");
            var toReturn = detailsSplit[0].replace("<span class='size'>", '') + ' ' + detailsSplit[1].replace('</span>', '');
            toReturn = toReturn.replace( /(<([^>]+)>)/ig, '')
            return toReturn;
          } else {
            return 'N/A';
          }
        } else {
          return 'N/A';
        }
      },
      fncGetQty( items ) {
        if( items.length > 0 && items[0].quantity != undefined && items[0].quantity != null ) {
          return items[0].quantity;
        } else {
          return 'N/A';
        }
      },
      fncGetServiceType( objItem ) {
        if (objItem.customer != objItem.createdBy) {
          return 'Assisted';
        } else if (objItem.customer == objItem.createdBy) {
          if (objItem.email != undefined && objItem.email.indexOf('@builders') != -1) {
            return 'ASM Issue';
          } else {
            return 'Self Service';
          }
        } else {
          return 'Unknown';
        }
        return 'Service Type';
      },
      fncGetDepartment( item ) {
        return item.departmentName;
      },
      fncGetBranch(item) {
        if( item.items.length > 0 ) {
          var parsedItem = JSON.parse( item.items[0].line_item_data );
          if( parsedItem.store_id != undefined && parsedItem.store_id != null ) {
            for( var b in this.branchList ) {
              if( this.branchList[b].code == parsedItem.store_id ) {
                return this.branchList[b].name;
              }
            }
            return 'Store True';
          } else {
            return 'N/A';
          }
        }
        return 'N/A';
      },
      fncGetStatusDropdown( objItem, item ) {

        if( item == 'status' ) {

          var isChecked = false;

          if (this.objAuthorize.department_active == 0 || this.objAuthorize.department_status_share == 1) {
            // return status as per normal

            return this.soStatusList;
          } else {

            var returnDepartment = 0;
            /*var departmentName = [];

            var returnDepartment = 0;
            var departmentName = [];

            var quoteRanges = [];

            var productCodes = [];
            var line_item_data = objItem.items;

            if( line_item_data.length > 0 ) {
              for( var l in line_item_data ) {
                quoteRanges.push( line_item_data[l].range_id );
                var lineObj = JSON.parse(line_item_data[l].line_item_data);
                if( line_item_data[l].code != null && productCodes.indexOf(line_item_data[l].code) == -1 ) {
                  // if( lineObj.pricing_code != null && productCodes.indexOf(lineObj.pricing_code) == -1 ) {
                  // if( lineObj.product_code != null && productCodes.indexOf(lineObj.product_code) == -1 ) {
                  // productCodes.push(lineObj.product_code);
                  productCodes.push(line_item_data[l].code);
                }
              }

              if (productCodes.length == 1) {
                for (var d in this.departmentList) {
                  if (this.departmentList[d].product_codes.length > 0) {
                    for (var c in this.departmentList[d].product_codes) {
                      if (productCodes[0] == this.departmentList[d].product_codes[c].value) {
                        returnDepartment = this.departmentList[d].id;
                      }
                    }
                  }
                }
              }
            }

            if( quoteRanges.length > 0 && returnDepartment == '0' ) {
              // } else if( objItem.range_id != null && objItem.range_id != undefined ) {
              var departmentRanges = this.departmentList;
              var filteredQuotes = [];
              for( var d in departmentRanges ) {
                for( var qr in quoteRanges ) {
                  for( var dr in departmentRanges[d].ranges ) {
                    if( quoteRanges[qr] == departmentRanges[d].ranges[dr] ) {
                      departmentName.push( departmentRanges[d].id );
                    }
                  }
                }
                var uniqueDepartment = departmentName.filter((v, i, a) => a.indexOf(v) === i);
                if (uniqueDepartment.length == 0) {
                  if (objItem.originator_department != '' && objItem.originator_department != null) {
                    for (var d in this.departmentList) {
                      if (this.departmentList[d].id == objItem.originator_department) {
                        returnDepartment = this.departmentList[d].id;
                      }
                    }
                  } else if (objItem.departmentUser != '' && objItem.departmentUser != null) {
                    returnDepartment = objItem.departmentUser;
                  } else {
                    var productCodes = [];
                    //var line_item_data = JSON.parse( objItem.product_codes ).split('|||');
                    var line_item_data = objItem.items;
                    if (line_item_data.length > 0) {
                      for (var l in line_item_data) {
                        var lineObj = JSON.parse(line_item_data[l].line_item_data);
                        if (lineObj.pricing_code != null && productCodes.indexOf(lineObj.pricing_code) == -1) {
                          productCodes.push(lineObj.pricing_code);
                        }
                      }
                    }
                    if (productCodes.length > 1) {
                      returnDepartment = 0;
                      for (var d in this.departmentList) {
                        if (this.departmentList[d].product_codes.length > 0) {
                          for (var c in this.departmentList[d].product_codes) {
                            if (productCodes[0] == this.departmentList[d].product_codes[c].value) {
                              returnDepartment = this.departmentList[d].id;
                            }
                          }
                        }
                      }
                    } else {
                      for (var d in this.departmentList) {
                        if (this.departmentList[d].product_codes.length > 0) {
                          for (var c in this.departmentList[d].product_codes) {
                            if (productCodes[0] == this.departmentList[d].product_codes[c].value) {
                              returnDepartment = this.departmentList[d].id;
                            }
                          }
                        }
                      }
                    }
                  }
                } else if (uniqueDepartment.length > 1) {
                  if (objItem.originator_department != '' && objItem.originator_department != null) {
                    returnDepartment = objItem.originator_department;
                  } else if (objItem.departmentUser != '' && objItem.departmentUser != null) {
                    returnDepartment = objItem.departmentUser;
                  } else {
                    returnDepartment = 0;
                  }
                } else {
                  returnDepartment = uniqueDepartment[0];
                }
              }

              if (returnDepartment == '0') {
                if (objItem.originator_department != '' && objItem.originator_department != null) {
                  returnDepartment = objItem.originator_department;
                } else if (objItem.departmentUser != '' && objItem.departmentUser != null) {
                  returnDepartment = objItem.departmentUser;
                } else {
                  returnDepartment = 0;
                }
              }
            }

            if( returnDepartment == '0' ) {
              if( objItem.originator_department != '' && objItem.originator_department != null ) {
                returnDepartment = objItem.originator_department;
              } else if( objItem.departmentUser != '' && objItem.departmentUser != null ) {
                returnDepartment = objItem.departmentUser;
              } else {
                returnDepartment = 0;
              }
            }*/

            returnDepartment = objItem.setDepartment;

            // now that we have the department id we can display the correct statuses
            var returnStatuses = [];
            var loggedRole = this.objAuthorize.roles[0];
            for (var s in this.soStatusList) {
              var statusRoles = this.soStatusList[s].roles != null ? this.soStatusList[s].roles.split(',') : [];

              // if( returnDepartment == this.soStatusList[s].department && statusRoles.indexOf( loggedRole ) != -1 ) {
              var objDepartments = [];
              if (this.soStatusList[s].department != null && this.soStatusList[s].department != 'null') {
                objDepartments = this.soStatusList[s].department.split(',');
              }

              if (returnDepartment != null && objDepartments.indexOf(String(returnDepartment)) != -1 && statusRoles.indexOf(loggedRole) != -1) {
                returnStatuses.push(this.soStatusList[s]);
              }
            }

            return returnStatuses;
          }
        }
      },
      fncCheckOrderNo( salesOrder ) {
        if( salesOrder.orderNo != null && salesOrder.orderNo != '' ) {
          return salesOrder.orderNo;
        } else {
          return 'N/A';
        }
      },
      fncPlaceOrder(salesOrder) {
        this.$store.dispatch({
          type: 'fncSoPlaceOrder',
          vendor: salesOrder.vendor,
          quote: salesOrder.quoteId,
          salesOrder: salesOrder
        })
      },
      fncCancelOrder(salesOrder) {
        var cancelStatusId = '';
        var cancelStatusDescription = '';
        for (var s in this.soStatusList) {
          if (this.soStatusList[s].is_cancel == 'Yes' ) {
            var cancelStatusId = this.soStatusList[s].id;
            var cancelStatusDescription = this.soStatusList[s].description;
          }
        }
        this.$store.dispatch({
          type: 'fncSoCancelOrder',
          vendor: salesOrder.vendor,
          quote: salesOrder.quoteId,
          statusId: cancelStatusId,
          statusDescription: cancelStatusDescription
        })
      },
      fncCanOrder(salesOrder) {
        //if (this.orderStatuses.indexOf(salesOrder.status) != -1 && (salesOrder.orderNo == '' || salesOrder.orderNo == null) && salesOrder.ordered == 0) {
        if (this.orderStatuses.indexOf(salesOrder.status) != -1 && salesOrder.ordered == 0 ) {
          return true;
        } else {
          return false;
        }
      },
      fncCanCancelOrder(salesOrder) {
        var is_cancelled = false;
        for (var s in this.soStatusList ) {
          if ( this.soStatusList[s].description == salesOrder.status && this.soStatusList[s].is_cancel == 'Yes' ) {
            is_cancelled = true;
          }
        }
        if (salesOrder.orderNo != '' && salesOrder.ordered != 0 && is_cancelled == false) {
          return true;
        } else {
          return false;
        }
      },
      fncIsCancelOrder(salesOrder) {

        /*var is_cancelled = false;
        for (var s in this.soStatusList) {
          if (this.soStatusList[s].description == salesOrder.status && this.soStatusList[s].is_cancel == 'Yes') {
            is_cancelled = true;
          }
        }*/
        // if (salesOrder.orderNo != '' && salesOrder.ordered != 0 && is_cancelled == true) {
        if ( salesOrder.items[0].isCancelled == 1 ) {
          return true;
        } else {
          return false;
        }
      },
      fncClearSearch() {
        this.search = '';
      },
      fncSoSettings(data) {

        var statusList = this.fncGetStatusDropdown( data, 'status' );

        this.$store.dispatch('fncSoSettingsNew', data);
      },
      fncShowDateFilter() {

        var startDate = new Date(this.reportDate[0]);
        startDate.setDate(startDate.getDate() + 1);
        startDate = new Date(startDate + ' GMT +0200').toISOString().slice(0, 10);

        var endDate = new Date(this.reportDate[1]);
        endDate.setDate(endDate.getDate() + 1);
        endDate = new Date(endDate + ' GMT +0200').toISOString().slice(0, 10);

        return '<small>' + startDate + ' ~ ' + endDate + '</small>';
      },
      fncBlurAll() {
        if( this.$refs.storeSelect ) {
          this.storeBlur = this.$refs.storeSelect[0].isActive;
        }

        if( this.$refs.vendorSelect ) {
          this.vendorBlur = this.$refs.vendorSelect[0].isActive;
        }

        if( this.$refs.statusSelect ) {
          this.statusBlur = this.$refs.statusSelect[0].isActive;
        }

        if( ( this.$refs.storeSelect && this.$refs.storeSelect[0].isActive == false ) && ( this.$refs.vendorSelect && this.$refs.vendorSelect[0].isActive == false ) && ( this.$refs.statusSelect && this.$refs.statusSelect[0].isActive == false ) ) {
          this.fncCustomReportSearch();
        }
      },
      fncClearFilter() {

        // localStorage.removeItem('soSetDays');
        this.soFilter = 0;
        this.hasFilters = false;
        this.objVendor = ['all'];
        this.objStatus = ['all'];
        this.objDepartment = ['all'];
        this.objStore = ['all'];
        // this.reportDate = '';

        localStorage.removeItem('soVendors');
        localStorage.removeItem('soStores');
        localStorage.removeItem('soStatus');
        localStorage.removeItem('soDepartment');

        this.fncReloadFilters();

      },
      fncClearFilters() {
        // localStorage.removeItem('soSetDays');
        this.soFilter = 0;
        this.hasFilters = false;
        this.objVendor = ['all'];
        this.objStatus = ['all'];
        this.objDepartment = ['all'];
        this.objStore = ['all'];

        localStorage.removeItem('soVendors');
        localStorage.removeItem('soStores');
        localStorage.removeItem('soStatus');
        localStorage.removeItem('soDepartment');

        var snackDetails = { color: 'success', message: 'Purchase Order Report filters have been cleared', display: true };
        this.$store.commit('setSnack', snackDetails);

        setTimeout(function(){
          window.location.reload();
        }, 500)
      },
      fncCustomReportSearch() {
        // this.$refs.dateSelect[0].closePopup();
        if (
          (this.objStatus.length > 0 && this.objStatus[0] != 'all') ||
          (this.objVendor.length > 0 && this.objVendor[0] != 'all') ||
          (this.objStore.length > 0 && this.objStore[0] != 'all') ||
          this.reportDate != '') {
          this.hasFilters = true;
        } else {
          this.hasFilters = false;
        }
        if( this.$refs.storeSelect ) {
          // this.$refs.storeSelect[0].isActive = false;
        }
        if( this.$refs.vendorSelect ) {
          // this.$refs.vendorSelect[0].isActive = false;
        }
        if( this.$refs.statusSelect ) {
          // this.$refs.statusSelect[0].isActive = false;
        }
        this.storeBlur = false;
        this.vendorBlur = false;
        this.statusBlur = false;

        this.$store.dispatch({
          type: 'fncPopulateSalesOrders',
          reload: false,
          vendors: this.objVendor,
          stores: this.objStore,
          status: this.objStatus,
          soDates: this.reportDate
        });

        /*this.$store.commit({
          type: 'fncFilterSalesOrderReports',
          date: this.reportDate,
          vendors: this.objVendor[0] == 'all' ? '' : this.objVendor,
          status: this.objStatus[0] == 'all' ? '' : this.objStatus,
          store: this.objStore[0] == 'all' ? '' : this.objStore,
          department: this.objDepartment[0] == 'all' ? '' : this.objDepartment
        });*/
      },
      setDates() {
        return window.localStorage.soDate.split(',');
      },
      fncShowVendorFlter() {
        var toReturn = '';
        for (var v in this.objVendor) {
          if (this.objVendor[v] != 'all') {
            for (var fv in this.objSalesOrderFilters.vendors) {
              if (this.objVendor[v] == this.objSalesOrderFilters.vendors[fv].id) {
                toReturn += '<small>' + this.objSalesOrderFilters.vendors[fv].text + '<br /></small>';
              }
            }
          }
        }
        return toReturn;
      },
      fncShowStoreFlter() {
        var toReturn = '';
        for (var v in this.objStore) {
          if (this.objStore[v] != 'all') {
            for (var fv in this.branchList) {
              if (this.objStore.indexOf(String(this.branchList[fv].code)) != -1) {
                toReturn += '<small>' + this.branchList[fv].name + '<br /></small>';
              }
            }
          }
        }
        return toReturn;
      },
      fncShowDepartmentFlter() {
        var toReturn = '';
        for (var v in this.objStatus) {
          if (this.objStatus[v] != 'all') {
            for (var fv in this.objSalesOrderFilters.status) {
              if (this.objStatus[v] == this.objSalesOrderFilters.status[fv].id) {
                toReturn += '<small>' + this.objSalesOrderFilters.status[fv].text + '<br /></small>';
              }
            }
          }
        }
        return toReturn;
      },
      fncShowStatusFlter() {
        var toReturn = '';
        for (var v in this.objStatus) {
          if (this.objStatus[v] != 'all') {
            for (var fv in this.objSalesOrderFilters.status) {
              if (this.objStatus[v] == this.objSalesOrderFilters.status[fv].id) {
                toReturn += '<small>' + this.objSalesOrderFilters.status[fv].text + '<br /></small>';
              }
            }
          }
        }
        return toReturn;
      },
      fncCheckVendor() {

        var isAll = false;
        if (this.objVendor.length > 1) {
          for (var v in this.objVendor) {
            if (this.objVendor[v] == 'all') {
              isAll = true;
            }
          }
        } else if (this.objVendor.length == 1 && this.objVendor[0] == 'all') {
          isAll = true;
        }

        if (this.objVendor.length > 1 && isAll == true && this.objVendor[0] == 'all') {
          isAll = false;
        }

        if (this.objVendor.length == 0) {
          isAll = true;
        }

        if (isAll == true) {
          this.objVendor = ['all'];
          localStorage.removeItem('soVendors');
        } else {
          var index = this.objVendor.indexOf('all');
          if (index > -1) {
            this.objVendor.splice(index, 1);
          }
        }
        this.fncCustomReportSearch();
      },
      fncCheckStore() {
        var isAll = false;
        if (this.objStore.length > 1) {
          for (var v in this.objStore) {
            if (this.objStore[v] == 'all') {
              isAll = true;
            }
          }
        } else if (this.objStore.length == 1 && this.objStore[0] == 'all') {
          isAll = true;
        }

        if (this.objStore.length > 1 && isAll == true && this.objStore[0] == 'all') {
          isAll = false;
        }

        if (this.objStore.length == 0) {
          isAll = true;
        }

        if (isAll == true) {
          this.objStore = ['all'];
          localStorage.removeItem('soStores');
        } else {
          var index = this.objStore.indexOf('all');
          if (index > -1) {
            this.objStore.splice(index, 1);
          }
        }
        // this.fncCustomReportSearch();
      },
      fncCheckStatus() {
        var isAll = false;
        if (this.objStatus.length > 1) {
          for (var s in this.objStatus) {
            if (this.objStatus[s] == 'all') {
              isAll = true;
            }
          }
        } else if (this.objStatus.length == 1 && this.objStatus[0] == 'all') {
          isAll = true;
        }

        if (this.objStatus.length > 1 && isAll == true && this.objStatus[0] == 'all') {
          isAll = false;
        }

        if (isAll == true) {
          this.objStatus = ['all'];
          localStorage.removeItem('soStatus');
        } else {
          var index = this.objStatus.indexOf('all');
          if (index > -1) {
            this.objStatus.splice(index, 1);
          }
        }
        // this.fncCustomReportSearch();
      },
      fncCheckDepartment() {
        var isAll = false;
        if (this.objDepartment.length > 1) {
          for (var s in this.objDepartment) {
            if (this.objDepartment[s] == 'all') {
              isAll = true;
            }
          }
        } else if (this.objDepartment.length == 1 && this.objDepartment[0] == 'all') {
          isAll = true;
        }

        if (this.objDepartment.length > 1 && isAll == true && this.objDepartment[0] == 'all') {
          isAll = false;
        }

        if (isAll == true) {
          this.objDepartment = ['all'];
          localStorage.removeItem('soDepartment');
        } else {
          var index = this.objDepartment.indexOf('all');
          if (index > -1) {
            this.objDepartment.splice(index, 1);
          }
        }
        // this.fncCustomReportSearch();
      },
      fncGoApp() {
        window.location = this.appUrl;
      },
      fncToggleFilters() {
        /*if (this.filterActive == true) {
          this.filterActive = false;
        } else {
          this.filterActive = true;
        }*/
        //this.$store.dispatch('fncPopulateSalesOrdersFilters', false);
        this.$store.commit('fncFilterNeedsReloadSo', true);
        this.$store.dispatch({
          type: 'fncPopulateSalesOrdersFilters',
          reload: false,
          vendors: this.objVendor[0] != 'all' ? this.objVendor : [],
          stores: this.objStore[0] != 'all' ? this.objStore : [],
          status: this.objStatus[0] != 'all' ? this.objStatus : [],
          soDates: this.reportDate
        });
        this.filterDrawer = true;
      },
      fncUpper(string) {
        return string.toUpperCase();
      },
      fncItemLength(items) {
        return items.length;
      },
      fncGetInstallationDate( item ) {
        for( var i in item ) {
          var lineData = item[i].line_item_data;
          var installationDate = 'N/A';
          if( lineData.indexOf('installation_appointment_date_start') != -1 ) {
            var timeSplit = lineData.split('installation_appointment_date_start');
            var newSplit = timeSplit[1].replace(/"/g, "");
            newSplit = newSplit.replace(/'/g, "");
            newSplit = newSplit.replace(/:/g, "");
            newSplit = newSplit.replace(/\//g,'');
            newSplit = newSplit.split(',');
            installationDate = newSplit[0];
            var onjInstallDate = installationDate.split(',');
            installationDate = onjInstallDate[ onjInstallDate.length - 1 ];
          }
          return installationDate;
        }
      },
      fncGetInstallationDescription( item ) {
        for( var i in item ) {
          var lineData = item[i].line_item_data;
          var installationDate = 'N/A';
          if( lineData.indexOf('installation_product_description_1') != -1 ) {
            var timeSplit = lineData.split('installation_product_description_1');
            var newSplit = timeSplit[1].replace(/"/g, "");
            newSplit = newSplit.replace(/'/g, "");
            newSplit = newSplit.replace(/:/g, "");
            newSplit = newSplit.replace(/\//g,'');
            newSplit = newSplit.split(',');
            installationDate = newSplit[0];
          }
          return installationDate;
        }
      },
      fncGetCustomerRating(item) {
        /*if( item.customerRating != '' ) {
          if( item.customerRating == '0' || item.customerRating == '' ) {
            return 'N/A';
          } else {
            return item.customerRating + ' - ';
          }
        }*/
      },
      fncGetOnsiteTime(item) {
        var statusName = '';
        for( var s in this.soStatusList ) {
          if( this.soStatusList[s].fs_on_site == 'Yes' || this.soStatusList[s].fs_on_site == '1' ) {
            statusName = this.soStatusList[s].description;
          }
        }
        var toReturn = 'N/A';
        if( this.manufacturerAudits[item.quoteId] != null ) {
          if( this.manufacturerAudits[item.quoteId][statusName] != null ) {
            toReturn = this.manufacturerAudits[item.quoteId][statusName].time;
          }
        }
        return toReturn;
      },
      fncGetJobComplete(item) {
        var statusName = '';
        for( var s in this.soStatusList ) {
          if( this.soStatusList[s].fs_job_complete == 'Yes' || this.soStatusList[s].fs_job_complete == '1' ) {
            statusName = this.soStatusList[s].description;
          }
        }
        var toReturn = 'N/A';
        if( this.manufacturerAudits[item.quoteId] != null ) {
          if( this.manufacturerAudits[item.quoteId][statusName] != null ) {
            toReturn = this.manufacturerAudits[item.quoteId][statusName].time;
          }
        }
        return toReturn;
      },
      fncGetCancellationReason(item) {
        var statusName = '';
        for( var s in this.soStatusList ) {
          if( this.soStatusList[s].fs_job_cancelled == 'Yes' || this.soStatusList[s].fs_job_cancelled == '1' ) {
            statusName = this.soStatusList[s].description;
          }
        }
        var toReturn = 'N/A';
        if( this.manufacturerAudits[item.quoteId] != null ) {
          if( this.manufacturerAudits[item.quoteId][statusName] != null ) {
            toReturn = this.manufacturerAudits[item.quoteId][statusName].data;
          }
        }
        if( toReturn == '' ) {
          toReturn = 'N/A';
        }
        return toReturn;
      },
      fncGetWidth(item) {
        for (var h in this.headers) {
          if (this.headers[h].value == item) {
            return this.headers[h].width;
          }
        }
      },
      fncDownloadCsv(data) {

        this.$store.dispatch({
          type: 'fncDownloadReportCsv',
          data: data,
          vendorList: this.vendorList,
          privileges: this.objAuthorize.privileges
        })

      },
      fncDownloadPdf(data) {
        this.$store.dispatch('fncDownloadReportSoPdf', data);
      },
      fncViewStatusPopup(saleReport) {
        this.$store.dispatch({
          type: 'fncGetSalesOrderHistory',
          quote: saleReport.quoteId,
          vendor: saleReport.vendor,
          quoteNo: saleReport.quoteNo
        })
      },
      fncChangeReportStatus(saleReport, statusId, doPrint = false, sendStatus) {

        if( sendStatus == true ) {
          var statusList = this.fncGetStatusDropdown( saleReport, 'status' );

          var modalDetails = { title: 'Update Purchase Order Report Status - ' + saleReport.quoteNo, component: 'modal-quote-status-report-update', mstate: true, params: { saleReport: saleReport, statusId: statusId, doPrint: doPrint, statusList: statusList } };
          this.$store.commit({
            type: 'setModal',
            details: modalDetails
          });
        } else {
          var modalDetails = { title: 'Update Purchase Order Report Status - ' + saleReport.quoteNo, component: 'modal-quote-status-report-update', mstate: true, params: { saleReport: saleReport, statusId: statusId, doPrint: doPrint } };
          this.$store.commit({
            type: 'setModal',
            details: modalDetails
          });
        }

      },
      fncFormatPrice(saleItem, currency, price) {

        var price = 0;
        if (this.objAuthorize.privileges.indexOf('VENDOR_COST_PRICE') != -1) {
          for (var i in saleItem.items) {
            var lineData = JSON.parse(saleItem.items[i].line_item_data);
            if (lineData.cost_price != null) {
              price = parseFloat(price) + parseFloat(parseFloat(lineData.cost_price) * saleItem.items[i].quantity);
            } else {
              price = parseFloat(saleItem.total);
            }
          }
        } else if (this.objAuthorize.privileges.indexOf('VENDOR_FULL_PRICE') != -1) {
          for (var i in saleItem.items) {
            price = parseFloat(price) + parseFloat(parseFloat(saleItem.items[i].price) * saleItem.items[i].quantity);
          }

        }

        return currency + price.toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");

        /*var newPrice = parseFloat(saleItem.total) * 1.15;
        return currency + newPrice.toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");*/

      },
      fncVendorName(vendorId) {
        for (var v in this.salesOrderVendors) {
          if (this.salesOrderVendors[v].id == vendorId) {
            return this.salesOrderVendors[v].name;
          }
        }

      },
      fncDownloadSalesOrder(salesOrder) {
        alert('PDF / CSV Download');
      },
      fncViewSalesOrder(order, doPrint, hasStatus = false) {

        this.$store.dispatch({
          type: 'fncSetQuoteDetails',
          quoteId: order.quoteId,
          quote: order.quoteNo,
          so: true,
          order: order,
          vendorList: this.vendorList,
          privileges: this.objAuthorize.privileges,
          doPrint: doPrint,
          hasStatus: hasStatus
        });

        /*this.$store.dispatch({
          type: 'fncViewSalesOrder',
          order: order,
          vendorList: this.vendorList,
          privileges: this.objAuthorize.privileges
        })*/
      },
      fncGetVendor(vendorId) {

        for (var v in this.vendorList) {
          if (this.vendorList[v].id == vendorId) {
            return this.vendorList[v].name;
          }
        }
      }
    },
    computed: {
      ...mapGetters([
        'objAuthorize',
        'salesOrderList',
        'salesOrderListFilter',
        'objSalesOrderFilters',
        'salesOrderVendors',
        'vendorList',
        'soStatusList',
        'soColumns',
        'soLoaded',
        'departmentList',
        'branchList',
        'manufacturerAudits',
        'soFilters',
        'filterNeedsReloadSo',
        'fncPopulateRoles',
        'userRoles',
        'vendorUsers'
      ])
    },
    beforeMount() {
      this.$store.dispatch('fncPopulateStatusList');
      this.$store.dispatch({
        type: 'fncPopulateUsers',
        context: 6,
        parent: -1
      });
      //this.$store.dispatch('fncPopulateVendors');
      //this.$store.dispatch('fncPopulateSalesOrders', false);
      var quoteNo = this.$route.query.quoteno;

      if (quoteNo != '' && this.$route.query.quoteno != 'undefined' && this.$route.query.quoteno != undefined && this.$route.query.quoteno != null) {
        this.soSearch = quoteNo;
      } else if( window.localStorage.soSearch != undefined && window.localStorage.soSearch != null ) {
      }

      if( this.$router.history.current.query.quoteNo ) {
        var querySearch = this.$router.history.current.query.quoteNo;
        localStorage.setItem('soSearch', this.$router.history.current.query.quoteNo);
        this.soSearch = this.$router.history.current.query.quoteNo;
      } else {
        var querySearch = this.soSearch
      }

      if( this.reportDate == '' ) {

        var dToday = new Date();
        var dateToday = dToday.toISOString().split('T')[0];

        var startDate = new Date(new Date().setDate(dToday.getDate() - 7));
        startDate = startDate.toISOString().split('T')[0];

        this.reportDate = [];

        this.reportDate.push( startDate );
        this.reportDate.push( dateToday );

        this.soFilter = 6;

        localStorage.setItem('soSetDays', this.soFilter);
        localStorage.setItem('soDate', this.reportDate);

      }

      this.$store.dispatch({
        type: 'fncPopulateSalesOrders',
        reload: false,
        vendors: this.objVendor[0] != 'all' ? JSON.parse(this.objVendor) : this.objVendor,
        stores: this.objStore[0] != 'all' ? JSON.parse(this.objStore) : this.objStore,
        status: this.objStatus[0] != 'all' ? JSON.parse(this.objStatus) : this.objStatus,
        search: querySearch,
        soDates: this.reportDate
      });
      /*this.$store.dispatch('fncPopulateStatusList');
      this.$store.dispatch('fncPopulateDepartments');
      this.$store.dispatch('fncPopulateBranches');*/

      // departmentProductCodes
      if( this.departmentList ) {
        if( this.departmentList ) {
          for( var d in this.departmentList ) {
            if( this.departmentList[d].product_codes != null && this.departmentList[d].product_codes.length > 0 ) {
              for( var x in this.departmentList[d].product_codes ) {
                this.departmentProductCodes[this.departmentList[d].product_codes[x]] = this.departmentList[d].name;
              }
            }
            if( this.departmentList[d].ranges != null && this.departmentList[d].ranges.length > 0 ) {
              for( var x in this.departmentList[d].ranges ) {
                this.departmentProductCodes[this.departmentList[d].ranges[x]] = this.departmentList[d].name;
              }
            }
          }
        }
      }
    },
    mounted() {
      var mainThis = this;
      setTimeout(function(){
        mainThis.loading = false;
        mainThis.newStatus = mainThis.globalModalParams.currentStatus;
        for( var s in mainThis.globalModalParams.statusList ) {
          mainThis.popupStatus.push({id: mainThis.globalModalParams.statusList[s].id, 'text': mainThis.globalModalParams.statusList[s].description});
        }
      }, 1500)
    },
    watch: {
      vendorUsers() {
        for( var u in this.vendorUsers ) {
          if( this.vendorUserList[this.vendorUsers[u].vendor] == undefined ) {
            this.vendorUserList[this.vendorUsers[u].vendor] = [];
          }
          /*if( this.vendorUserList[this.vendorUsers[u].vendor][this.vendorUsers[u].roleId] == undefined ) {
            this.vendorUserList[this.vendorUsers[u].vendor][this.vendorUsers[u].roleId] = [];
          }*/
          this.vendorUserList[this.vendorUsers[u].vendor].push( this.vendorUsers[u] );
        }
      },
      page() {
        if( this.$router.history.current.query.p == undefined || this.$router.history.current.query.p == 'undefined' ) {
          this.$router.push({path: '/reports/sales-order-reports', query: {p: 1}});
        }
        if( this.page != this.$router.history.current.query.p ) {
          this.$router.push({path: '/reports/sales-order-reports', query: {p: this.page}});
          this.$router.go();
        }
      },
      salesOrderList() {
        if( this.salesOrderList.length > 0 ) {
          this.totalPages = Math.ceil( this.salesOrderList[0].soCount / 10 );
          this.totalQuoteRecords = this.salesOrderList[0].soCount;
        }
      },
      salesOrderListFilter() {

        if( this.salesOrderListFilter != undefined && this.salesOrderListFilter.length > 0 ) {
          var stores = [];

          for( var s in this.salesOrderListFilter ) {
            if( this.salesOrderListFilter[s].items.length > 0 && this.salesOrderListFilter[s].items ) {
              var parsedItem = JSON.parse( this.salesOrderListFilter[s].items[0].line_item_data );
              if( parsedItem.store_id != undefined && parsedItem.store_id != null ) {
                for( var b in this.branchList ) {
                  if( this.branchList[b].code == parsedItem.store_id ) {
                    stores[this.branchList[b].code] = this.branchList[b].name;
                  }
                }
            }

            } else {
              stores['na'] = 'N/A';
            }
          }

          this.$store.dispatch('fncPopulateVendors');
          this.$store.dispatch('fncPopulateStatusList');
          this.$store.dispatch('fncPopulateDepartments');
          this.$store.dispatch('fncPopulateBranches');

          this.$store.commit('fncSetSoStoreFilters', stores);
        }
      },
      /*reportDate() {
        this.fncCustomReportSearch();
      },*/
      departmentList() {
        if( this.departmentList ) {
          for( var d in this.departmentList ) {
            if( this.departmentList[d].product_codes != null && this.departmentList[d].product_codes.length > 0 ) {
              for( var x in this.departmentList[d].product_codes ) {
                this.departmentProductCodes[this.departmentList[d].product_codes[x]] = this.departmentList[d].name;
              }
            }
            if( this.departmentList[d].ranges != null && this.departmentList[d].ranges.length > 0 ) {
              for( var x in this.departmentList[d].ranges ) {
                this.departmentProductCodes[this.departmentList[d].ranges[x]] = this.departmentList[d].name;
              }
            }
          }
        }
      },
      soStatusList() {
        /*for (var s in this.soStatusList) {
          if (this.soStatusList[s].is_vendor == true || this.soStatusList[s].is_vendor == 'Yes') {
            this.orderStatuses.push(this.soStatusList[s].description);
            // this.hasOrders = true;
          }
        }

        if( this.hasOrders == true ) {
          if( this.headers[0].text != 'Order NO' ) {
            this.headers.unshift({ text: 'Order Details', value: 'orderDetails', width: '200px' });
            this.headers.unshift({ text: 'Order NO', value: 'orderNo', width: '100px' });
          }
        }*/
      },
      soColumns() {

        this.headers = [{ text: 'View Order', value: 'view', width: '100px' }];

        if( this.objAuthorize.privileges.indexOf('VENDOR_FACTORY') != -1 ) {
          this.headers.push({ text: 'Print Jobcard', value: 'print', width: '175px' });
        }

        if( this.objAuthorize.privileges.indexOf('VENDOR_FACTORY') != -1 ) {
          this.headers.push({ text: 'Print Invoice', value: 'print', width: '175px' });
        }

        this.tableWidth = 450;
        for (var h in this.soColumns) {
          if (this.soColumns[h].checked == true) {
            if (this.soColumns[h].width == 'auto') {
              var colWidth = '100px';
              if (this.soColumns[h].id == 'date') {
                colWidth = '200px';
              } else if (this.soColumns[h].id == 'vendorName') {
                colWidth = '200px';
              } else if (this.soColumns[h].id == 'items') {
                colWidth = '100px';
              } else if (this.soColumns[h].id == 'status') {
                colWidth = '400px';
              } else if (this.soColumns[h].id == 'fullname') {
                colWidth = '200px';
              } else if (this.soColumns[h].id == 'quoteNo') {
                colWidth = '150px';
              } else if (this.soColumns[h].id == 'soNo' || this.soColumns[h].id == 'customerRating') {
                colWidth = '150px';
              } else if (this.soColumns[h].id == 'totalPrice') {
                colWidth = '125px';
              } else if (this.soColumns[h].id == 'email' || this.soColumns[h].id == 'soDepartment') {
                colWidth = '200px';
              } else if (this.soColumns[h].id == 'contactnum') {
                colWidth = '175px';
              } else if (this.soColumns[h].id == 'download') {
                colWidth = '175px';
              } else if (this.soColumns[h].id == 'purchaseOrder' || this.soColumns[h].id == 'quoteRegion' || this.soColumns[h].id == 'bwSalesOrderNo' || this.soColumns[h].id == 'soGlassType' || this.soColumns[h].id == 'soGlassSize' || this.soColumns[h].id == 'soBranch' || this.soColumns[h].id == 'onsiteTime' || this.soColumns[h].id == 'jobComplete') {
                colWidth = '200px';
              } else if (this.soColumns[h].id == 'originatorName' || this.soColumns[h].id == 'installationDate' || this.soColumns[h].id == 'installationDescription' || this.soColumns[h].id == 'cancellationReason') {
                colWidth = '250px';
              } else if (this.soColumns[h].id == 'soGlassType' || this.soColumns[h].id == 'soGlassSize') {
                colWidth = '230px';
              } else if( this.soColumns[h].id == 'responsibleReps' || isNaN(this.soColumns[h].id) == false ) {
                colWidth = '350px';
              }

              this.headers.push({ text: this.soColumns[h].label, value: this.soColumns[h].id, width: colWidth });
              this.tableWidth = this.tableWidth + parseInt(colWidth);
            } else {
              this.headers.push({ text: this.soColumns[h].label, value: this.soColumns[h].id, width: this.soColumns[h].width });
              this.tableWidth = this.tableWidth + parseInt(this.soColumns[h].width);
            }
          }
        }
        //this.headers.push({ text: 'Download', value: 'download', width: '100px' });
      },
      soLoaded() {
        if( this.salesOrderListFilter.length > 0 ) {
          var newSo = [];
          var statusList = this.fncGetStatusDropdown(this.salesOrderListFilter[0], 'status');

          for( var so in this.salesOrderListFilter ) {

            var statusText = false;
            if( this.salesOrderListFilter[so].status == 'Manufactured' || this.objAuthorize.privileges.indexOf('VENDOR_FACTORY') == '-1' ) {
              statusText = false;
            } else {
              var nextIndex = 0;

              console.log('Status List');
              console.log( statusList );

              for( var i in statusList ){
                if( statusList[i].description == this.salesOrderListFilter[so].status ) {

                  console.log('Current Index');
                  console.log( i );

                  nextIndex = parseInt(i) + 1;

                  console.log('New Index');
                  console.log( nextIndex );

                }
              }
              if( nextIndex >= statusList.length ) {
                statusText = false;
              } else {
                statusText = statusList[nextIndex].description;
              }
            }
            this.salesOrderListFilter[so].statusText = statusText;
            newSo.push( this.salesOrderListFilter[so] );
          }
        }
      }
    },
    mounted() {

      this.objVendor = this.objVendor[0] == 'all' ? this.objVendor : JSON.parse( this.objVendor );
      this.objStore = this.objStore[0] == 'all' ? this.objStore : JSON.parse( this.objStore );
      this.objStatus = this.objStatus[0] == 'all' ? this.objStatus : JSON.parse( this.objStatus );

      if( this.$router.history.current.query.p != undefined && this.$router.history.current.query.p != 'undefined' ) {
        this.getPage = this.$router.history.current.query.p;
      } else {
        this.$router.push({path: '/reports/sales-order-reports', query: {p: 1}});
      }

      this.page = parseInt(this.getPage);

      // sort the new headers
      this.headers = [{ text: 'View Order', value: 'view', width: '100px' }];

      if( this.objAuthorize.privileges.indexOf('VENDOR_FACTORY') != -1 ) {
        this.headers.push({ text: 'Print Jobcard', value: 'print', width: '175px' });
      }

      if( this.objAuthorize.privileges.indexOf('VENDOR_FACTORY') != -1 ) {
        this.headers.push({ text: 'Print Invoice', value: 'print', width: '175px' });
      }

      this.tableWidth = 450;
      for (var h in this.soColumns) {
        if (this.soColumns[h].checked == true) {
          if (this.soColumns[h].width == 'auto') {
            var colWidth = '100px';
            if (this.soColumns[h].id == 'date') {
              colWidth = '200px';
            } else if (this.soColumns[h].id == 'vendorName') {
              colWidth = '200px';
            } else if (this.soColumns[h].id == 'items') {
              colWidth = '100px';
            } else if (this.soColumns[h].id == 'status') {
              colWidth = '400px';
            } else if (this.soColumns[h].id == 'fullname') {
              colWidth = '200px';
            } else if (this.soColumns[h].id == 'quoteNo') {
              colWidth = '150px';
            } else if (this.soColumns[h].id == 'soNo' || this.soColumns[h].id == 'customerRating') {
              colWidth = '150px';
            } else if (this.soColumns[h].id == 'totalPrice') {
              colWidth = '125px';
            } else if (this.soColumns[h].id == 'email' || this.soColumns[h].id == 'soDepartment') {
              colWidth = '200px';
            } else if (this.soColumns[h].id == 'contactnum') {
              colWidth = '175px';
            } else if (this.soColumns[h].id == 'download') {
              colWidth = '175px';
            } else if (this.soColumns[h].id == 'purchaseOrder' || this.soColumns[h].id == 'quoteRegion' || this.soColumns[h].id == 'bwSalesOrderNo' || this.soColumns[h].id == 'soGlassType' || this.soColumns[h].id == 'soGlassSize' || this.soColumns[h].id == 'soBranch' || this.soColumns[h].id == 'onsiteTime' || this.soColumns[h].id == 'jobComplete') {
              colWidth = '200px';
            } else if (this.soColumns[h].id == 'originatorName' || this.soColumns[h].id == 'installationDate' || this.soColumns[h].id == 'installationDescription' || this.soColumns[h].id == 'cancellationReason') {
              colWidth = '250px';
            } else if (this.soColumns[h].id == 'soGlassType' || this.soColumns[h].id == 'soGlassSize') {
              colWidth = '230px';
            } else if( this.soColumns[h].id == 'responsibleReps' || isNaN(this.soColumns[h].id) == false ) {
              colWidth = '350px';
            }
            this.headers.push({ text: this.soColumns[h].label, value: this.soColumns[h].id, width: colWidth });
            this.tableWidth = this.tableWidth + parseInt(colWidth);
          } else {
            this.headers.push({ text: this.soColumns[h].label, value: this.soColumns[h].id, width: this.soColumns[h].width });
            this.tableWidth = this.tableWidth + parseInt(this.soColumns[h].width);
          }
        }
      }

      var quoteNo = this.$route.query.quoteno;
      if (quoteNo != '') {
        this.search = quoteNo;
      }
      if (
        (this.objStatus.length > 0 && this.objStatus[0] != 'all') ||
        (this.objVendor.length > 0 && this.objVendor[0] != 'all') ||
        (this.objStore.length > 0 && this.objStore[0] != 'all') ||
        (this.objDepartment.length > 0 && this.objDepartment[0] != 'all') ||
        this.reportDate != '') {
        this.hasFilters = true;
        this.filterActive = true;
      }

      this.appUrl = window.localStorage.appUrl;

      var soSetDays = localStorage.getItem('soSetDays');

      if( soSetDays != '' && soSetDays != '0' ) {
        this.soFilter = parseInt( soSetDays );
      }

      // this.soFilter = 6;

      /*setInterval(function() {
        window.location.reload();
      }, 600000);*/

    },
    components: {
      DatePicker
    }
  }
</script>

<style scoped>
  /* @import '../../shared/assets/css/shared.css';*/
</style>
